import React from 'react';
import BarButtonFw, { BUTTON_DEFAULT } from '../../../../../framework/bar-button/BarButtonFw';
import FormFw from '../../../../../framework/form/FormFw';
import GridFw, { COLUMN_DEFAULT, SELECTION_TYPE } from '../../../../../framework/grid/GridFw';
import { BasePage } from '../../../../../framework/pages/BasePage';
import { MessageUtil } from '../../../../../util/MessageUtil';
import FormGridFw, { FORM_GRID_MODE } from '../../../../../framework/form-grid/FormGridFw';
import { LoadUtil } from '../../../../../framework/util/LoadUtil';
import { getValidationEstacionModal } from './getValidationEstacionModal';
import { EnvConstants } from '../../../../../EnvConstants';

export class AgregarTitularFacturaModal extends BasePage {
    constructor(props) {
        super(props);
        this.titularFacturaForm = {};
        this.crearEmpresaFacturaForm = {};
    };

    createPageProperties = (pageApi) => {
        return {
            validation: getValidationEstacionModal,
        };
    }

    renderPage(pageApi) {
        const validarForm = () => {
            if (this.titularFacturaForm.titular_factura === "" || !this.titularFacturaForm.titular_factura) {
                MessageUtil(
                    "warning",
                    "Alerta!",
                    "Seleccione un Titular de Facturación."
                );
                
                return false;
            }
            return true;
        }

        const validarFormCreate = () => {
            if (this.crearEmpresaFacturaForm.raz_soc === "" || !this.crearEmpresaFacturaForm.raz_soc) {
                MessageUtil(
                    "warning",
                    "Alerta!",
                    "Ingrese un Razón Social de la empresa."
                );
                
                return false;
            }

            if (this.crearEmpresaFacturaForm.ruc === "" || !this.crearEmpresaFacturaForm.ruc) {
                MessageUtil(
                    "warning",
                    "Alerta!",
                    "Ingrese un RUC de la empresa."
                );
                
                return false;
            }

            if (this.crearEmpresaFacturaForm.direccion === "" || !this.crearEmpresaFacturaForm.direccion) {
                MessageUtil(
                    "warning",
                    "Alerta!",
                    "Ingrese un dirección de la empresa."
                );
                
                return false;
            }

            return true;
        }

        const barButtonconfig = {
            fields:[
                {...BUTTON_DEFAULT.SAVE , onClick: () => {
                    
                    if (validarForm()) {
                        const data = {
                            id_empresa: pageApi.name.data.id_empresa,
                            id_titular: this.titularFacturaForm.titular_factura,
                            id_division: 1,
                        };

                        LoadUtil.loadByQueryId({
                            url: EnvConstants.GET_FW_FORM_URL_UPDATE_BASE(),
                            queryId: 867,
                            params: data,
                            fnOk: (res) => {
                                if(!res?.error) {
                                    MessageUtil("success", res.msg, "");
                                    pageApi.hideThisModal();
                                    pageApi.name.fnLoadForm(parseInt(data.id_titular))
                                } else {
                                    MessageUtil("error", res.error, "");
                                }  
                            }
                        })
                    }
                }},
            ]
        }

        const formConfig = {
            mode: FORM_GRID_MODE.FORM_ADD,
            afterAddEvent: (data) => {
                pageApi.getEvent('afterAddEvent')(data);
                pageApi.hideThisModal();
            },
            form: {
                fields:[
                    {
                        name:'titular_factura',
                        type: 'select',
                        label:'Titular Factura',
                        column: 12,
                        search: true,
                        load: { queryId: 866 },
                        onChange: (value, values) => { this.titularFacturaForm.titular_factura = value },
                        required: true
                    },
                ]
            },
            bar: barButtonconfig
        } 

        const barButtonconfigCreate = {
            fields:[
                {...BUTTON_DEFAULT.SAVE , onClick: () => {
                    
                    if (validarFormCreate()) {
                        const data = {
                            id_empresa: pageApi.name.data.id_empresa,
                            raz_soc: this.crearEmpresaFacturaForm.raz_soc,
                            ruc: this.crearEmpresaFacturaForm.ruc,
                            direccion: this.crearEmpresaFacturaForm.direccion
                        };

                        LoadUtil.loadByQueryId({
                            url: EnvConstants.GET_FW_FORM_URL_UPDATE_BASE(),
                            queryId: 871,
                            params: data,
                            fnOk: (res) => {
                                if(!res?.error) {
                                    MessageUtil("success", res.msg, "");
                                    pageApi.hideThisModal();
                                    pageApi.name.fnLoadForm(parseInt(res.dataObject.id_titular))
                                } else {
                                    MessageUtil("error", res.error, "");
                                }  
                            }
                        })
                    }
                }},
            ]
        }

        const formConfigCreate = {
            mode: FORM_GRID_MODE.FORM_ADD,
            afterAddEvent: (data) => {
                pageApi.getEvent('afterAddEvent')(data);
                pageApi.hideThisModal();
            },
            form: {
                fields:[
                    {
                        name: 'raz_soc',
                        type: 'text',
                        label:'Razón Social',
                        column: 12,
                        onChange: (value, values) => { this.crearEmpresaFacturaForm.raz_soc = value },
                        required: true
                    },
                    {
                        name: 'ruc',
                        type: 'text',
                        label:'RUC',
                        column: 12,
                        onChange: (value, values) => { this.crearEmpresaFacturaForm.ruc = value },
                        required: true
                    },
                    {
                        name: 'direccion',
                        type: 'text',
                        label:'Dirección',
                        column: 12,
                        onChange: (value, values) => { this.crearEmpresaFacturaForm.direccion = value },
                        required: true
                    },
                ]
            },
            bar: barButtonconfigCreate
        } 

    
        return (
            <>
                <p align="center"><b>ASOCIAR CLIENTE</b></p>
                <FormFw
                    name="titularFacturaForm" 
                    getParentApi={pageApi.getApi}
                    config={formConfig.form}
                />
                <BarButtonFw
                    name="bar"
                    getParentApi={pageApi.getApi}
                    config={barButtonconfig}
                />
                <br></br>
                <p align="center"><b>CREAR CLIENTE</b></p>
                <FormFw
                    name="crearEmpresaFacturaForm" 
                    getParentApi={pageApi.getApi}
                    config={formConfigCreate.form}
                />
                <BarButtonFw
                    name="bar"
                    getParentApi={pageApi.getApi}
                    config={barButtonconfigCreate}
                />
            </>
        )

    }
    
}